import PropTypes from 'prop-types';
import CustomLink from './CustomLink';

function MobileNav({ isOpen, t }) {
  return (
    <div className={`${isOpen ? 'block h-screen' : 'hidden'} px-[5%]`}>
      <div className="relative">
        <ul className="mt-10">
          <li className="text-[2.5em]">
            <a
              id="link-guide1"
              className="relative hover:after:absolute hover:after:bottom-[-2px] hover:after:left-0 hover:after:right-0 hover:after:h-0.5 hover:after:bg-white font-bold"
              target="_blank"
              rel="noopener noreferrer"
              href={t('link.guideUrl')}
            >
              {t('link.guide')}
            </a>
          </li>
          <li className="text-[2.5em]">
            <a
              id="link-upadteNote1"
              className="relative hover:after:absolute hover:after:bottom-[-2px] hover:after:left-0 hover:after:right-0 hover:after:h-0.5 hover:after:bg-white font-bold"
              target="_blank"
              rel="noopener noreferrer"
              href={t('link.updateNoteUrl')}
            >
              {t('link.updateNote')}
            </a>
          </li>
          <li className="text-m mt-20">
            <CustomLink
              id="link-login1"
              className="relative hover:after:absolute hover:after:bottom-[-2px] hover:after:left-0 hover:after:right-0 hover:after:h-0.5 hover:after:bg-white font-bold"
              href="/login"
              name={t('link.login')}
            />
          </li>
        </ul>
        <div className="fixed w-full bottom-[5vh] left-0 px-[5%]">
          <h3 className="font-bold text-r mb-2.5 text-light-gray">{t('contactUs')}</h3>
          <div>
            <a
              id="mailto-1"
              className="inline-block bg-dark-gray text-gray-d py-[7px] px-3.5 rounded font-bold text-s hover:bg-lime hover:text-black-10 transition-colors"
              href="mailto:cs@bgms.live?subject=[BGMs] Inquiry email"
            >
              {t('link.emailUs')}
            </a>
            <p className="float-right font-bold mt-2.5 mr-[10%]">{t('languages.kr')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

MobileNav.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default MobileNav;
